import { IApiService } from './IApiService';
import { ApiService } from './ApiService';
import apiResponse from './ApiResponse';
import { SectionView } from '../views/DashboardView';

export class SurveyResponseStore {
  constructor(private readonly api: IApiService = new ApiService()) {}

  public async Write(section: SectionView, groupId: number, surveyId: number) {
    try {
      // Clean the section object to only include SectionView properties
      const cleanSection: SectionView = {
        id: section.id,
        name: section.name,
        description: section.description,
        questions: section.questions,
      };

      const response = await this.api.post(`cohort/${groupId}/section/responses`, {
        sectionView: cleanSection,
        surveyId: surveyId,
      });
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
